/**
 * DO NOT MANUALLY EDIT THIS FILE
 * This file is generated automatically by the build script on prebuild step.
 * Please refer to documentation for more information
 */

export default function MetaCategories({ children }) {
  return children({
    art: [
      'zeichnungen',
      'gemaelde',
      'pop-art',
      'fotografie',
      'collage',
      'collage/foto',
      'abstrakt',
      'kunstdrucke',
      'skulpturen',
      'fotografie/portraits',
      'gemaelde/oel',
      'fotografie/akte',
      'kunstdrucke/lino',
      'zeichnungen/tiere',
      'konzeptuell',
      'akte',
      'fotografie/mode',
      'street-art',
      'digital',
      'fotografie/stillleben',
      'gemaelde/abstrakt',
      'gemaelde/landschaften',
      'gemaelde/botanisch/blumen',
      'zeichnungen/tiere/voegel',
      'landschaften',
      'fotografie/wildtiere',
      'fotografie/natur',
      'kunstdrucke/botanisch',
      'fotografie/dokumentarfilm',
      'fotografie/architektur',
      'zeichnungen/bleistift',
      'fotografie/abstrakt',
      'stillleben',
      'installation',
      'gemaelde/acryl',
      'natur',
      'grafisch',
      'fotografie/surrealistisch',
      'gemaelde/stadtansichten/london',
      'zeichnungen/realistisch',
      'dadaismus',
      'geometrisch',
      'minimalistisch',
      'fotorealismus',
      'fotografie/konzeptuell',
      'fotografie/urban',
      'fotografie/tiere/hunde',
      'fotografie/sport',
      'gemaelde/botanisch/baeume',
      'gemaelde/akte',
      'zeichnungen/holzkohle',
      'portraits',
      'zeichnungen/natur',
      'politik',
      'gemaelde/stillleben',
      'zeichnungen/tinte',
      'figurativ',
      'botanisch/blumen',
      'botanisch',
      'skulpturen/holz',
      'fotografie/tiere',
      'fotografie/transportwesen-autos/autos',
      'gemaelde/tiere',
      'skulpturen/bronze',
      'spiritualitaet/religion',
      'surrealistisch',
      'gemaelde/natur',
      'musik',
      'fotografie/unterwasser',
      'skulpturen/papier',
      'skulpturen/glas',
      'gemaelde/landschaften/strand',
      'zeichnungen/buntstift',
      'fotografie/tiere/voegel',
      'fotografie/tiere/pferde',
      'gemaelde/tiere/hunde',
      'zeichnungen/botanisch',
      'tiere/katzen',
      'gemaelde/tiere/pferde',
      'zeichnungen/landschaften',
      'zeichnungen/musik',
      'skulpturen/kunststoff',
      'zeichnungen/geometrisch',
      'zeichnungen/akte',
      'skulpturen/tiere',
      'zeichnungen/kreide',
      'skulpturen/stein',
      'skulpturen/abstrakt',
      'kunstdrucke/pop-art',
      'gemaelde/spiritualitaet/religion',
      'zeichnungen/abstrakt',
      'spiritualitaet',
      'gemaelde/farbfeld',
      'gemaelde/figurativ',
      'kunstdrucke/siebdruck',
      'zeichnungen/portraits',
      'collage/papier',
      'architektur',
      'gemaelde/mixed-media',
      'stadtansichten',
      'gemaelde/tinte',
      'prominente',
      'fotografie/landschaften',
      'zeichnungen/minimalistisch',
      'fotografie/minimalistisch',
      'gemaelde/gouache',
      'gemaelde/aquarell',
      'fotografie/digital',
      'kunstdrucke/lithografie',
      'fotografie/farbe',
      'fotografie/schwarz-weiss',
      'kunstdrucke/digital',
      'abstrakt/landschaften',
      'fotografie/stadtansichten/new-york',
      'gemaelde/aquarell/abstrakt',
      'gemaelde/oel/abstrakt',
      'gemaelde/acryl/abstrakt',
      'zeichnungen/mode',
    ],
    artist: [
      'oesterreichisch',
      'belgisch',
      'kanadisch',
      'deutsch',
      'spanisch',
      'franzoesisch',
      'britisch',
      'griechisch',
      'italienisch',
      'japanisch',
      'niederlaendisch',
      'polnisch',
      'russisch',
      'amerikanisch',
      'kollagist',
      'digitale-kuenstler',
      'installationskuenstler',
      'maler',
      'maler/impressionistisch',
      'fotografen/weiblich',
      'fotografen/abstrakt',
      'fotografen/surrealistisch',
      'grafiker',
      'bildhauer',
      'bildhauer/weiblich',
      '',
      'afrikanisch',
      'asiatisch',
      'europaeisch',
      'lateinamerikanisch',
      'skandinavisch',
      'abstrakt/weiblich',
      'art-deco',
      'cartoon',
      'konzeptuell',
      'kubismus',
      'dadaismus',
      'expressionistisch',
      'figurativ',
      'geometrisch',
      'grafisch',
      'illustrativ',
      'impressionistisch/weiblich',
      'minimalistisch',
      'fotorealismus',
      'pop-art/weiblich',
      'realistisch',
      'street-art',
      'surrealistisch',
    ],
  });
}
